'use strict';
import angular from 'angular';

angular.module('workflows.services', [])
    .service('WorkflowsService', WorkflowsService)
    .service('WorkflowsFactory', WorkflowsFactory);

WorkflowsService.$inject = ['WorkflowsFactory', '$q', 'Upload', 'AppConfig', '$http'];

function WorkflowsService(WorkflowsFactory, $q, Upload, AppConfig, $http) {
    var service = {};
    service.workflowsList = null;
    service.workflowTaskList = null;
    service.workflowTaskInterlockingList = null;
    service.workflowTypes = null;
    service.workflowAction = null;
    service.workflowActions = null;
    service.routingRuleSets = null;
    service.routingRulesList = null;
    service.routingConditions = null;
    service.lineItemStatusList = null;
    service.flightStatusList = null;
    service.orderStatusList = null;
    service.clientStatusList = null;
    service.workflowInfo = null;

    service.getWorkflowTypes = function() {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTypes().get().$promise.then(function(data) {
            service.workflowTypes = data.workflowTypes;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflows types");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWorkflowsList = function(clusterId, showAll) {
        var deferred = $q.defer();
        var params = { 'clusterId': clusterId, 'showAll': (showAll ? 'yes' : 'no') };
        WorkflowsFactory.workflows().get(params).$promise.then(function(data) {
            service.workflowsList = data.workflows;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflows list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addWorkflow = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.workflows().save({
            'workflow': 'workflow'
        }, param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error saving workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.exportWorkflow = function(workflowId) {
        let deferred = $q.defer();
        $http.get(AppConfig.IO_API_URL + 'workflows/export', {
            params: {'id': workflowId}}).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            console.log("error exporting workflow");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.importWorkflow = function(customFile) {
        var deferred = $q.defer();
        Upload.upload({
            url: AppConfig.IO_API_URL + 'workflows/import',
            file: customFile
        }).success(function(data, status, headers, config) {
            if (data.result){
                deferred.resolve(data.result);
            }else{
                deferred.reject();
            }
        }).error(function(error) {
            deferred.reject();
        });
        return deferred.promise;
    };

    service.addWorkflowAction = function(params) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowAction().save(params).$promise.then(function(data) {
            service.workflowAction = data.workflowAction;
            deferred.resolve();
        }, function(response) {
            console.log("error saving workflow action");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateWorkflow = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.workflows().update({
            'workflow': 'workflow'
        }, param).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error updating workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateWorkflowAction = function(params) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowAction().update(params).$promise.then(function(data) {
            service.workflowAction = data.workflowAction;
            deferred.resolve();
        }, function(response) {
            console.log("error updating workflow action");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteWorkflow = function(workflowId) {
        var deferred = $q.defer();

        WorkflowsFactory.workflows().delete({
            'workflow': 'workflow',
            'id': workflowId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(error) {
            console.log("error deleting workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.toggleWorkflowState = function(workflowId) {
        var deferred = $q.defer();

        WorkflowsFactory.toggleWorkflowState().update({
            'workflow': 'workflow',
            'id': workflowId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(error) {
            console.log("error toggling workflow state");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWorkflowInfo = function(workflowId) {
        var deferred = $q.defer();
        WorkflowsFactory.workflows().get({
            'workflow': 'workflow',
            'id': workflowId
        }).$promise.then(function(data) {
            service.workflowInfo = data.workflow;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflow info");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWorkflowTasksList = function(workflowId) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTasks().get({
            'workflowTasks': 'workflowTasks',
            'workflowId': workflowId
        }).$promise.then(function(data) {
            service.workflowTaskList = data.workflowTasks;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflows tasks list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addWorkflowTask = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTasks().save({
            'workflowTasks': 'workflowTask'
        }, param).$promise.then(function(data) {
            if(data && data.errors) {
                deferred.reject(data.errors);
            }else if(data && data.workflowTask) {
                deferred.resolve(data.workflowTask);
            }else {
                deferred.reject(['error saving workflow task']);
            }
        }, function(response) {
            console.log("error saving workflow task");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateWorkflowTask = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTasks().update({
            'workflowTasks': 'workflowTask'
        }, param).$promise.then(function(data) {
            if(data && data.errors) {
                deferred.reject(data.errors);
            }else if(data && data.workflowTask) {
                deferred.resolve(data.workflowTask);
            }else {
                deferred.reject(['error updating workflow task']);
            }
        }, function(response) {
            console.log("error updating workflow task");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteWorkflowTask = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTasks().delete({
            'workflowTasks': 'workflowTask',
            'id': id
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting workflow task");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWorkflowTaskInterlockingsList = function(workflowId) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTaskInterlockings().get({
            'workflowTaskInterlockings': 'workflowTaskInterlockings',
            'workflowId': workflowId
        }).$promise.then(function(data) {
            service.workflowTaskInterlockingList = data.workflowTaskInterlockings;
            deferred.resolve(data);
        }, function(response) {
            console.log("error loading workflow task interlockings list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addWorkflowTaskInterlocking = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTaskInterlockings().save({
            'workflowTaskInterlockings': 'workflowTaskInterlocking'
        }, param).$promise.then(function(data) {
            if(data.workflowTaskInterlocking){
                deferred.resolve(data.workflowTaskInterlocking);
            }else{
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("error saving workflow task interlocking");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateWorkflowTaskInterlocking = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTaskInterlockings().update({
            'workflowTaskInterlockings': 'workflowTaskInterlocking'
        }, param).$promise.then(function(data) {
            if(data.workflowTaskInterlocking){
                deferred.resolve(data.workflowTaskInterlocking);
            }else{
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("error saving workflow task interlocking");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteWorkflowTaskInterlocking = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.workflowTaskInterlockings().delete({
            'workflowTaskInterlockings': 'workflowTaskInterlocking',
            'id': id
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting workflow task interlocking");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addInterlockingTaskSet = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.interlockingTaskSets().save({
            'interlockingTaskSets': 'interlockingTaskSet'
        }, param).$promise.then(function(data) {
            deferred.resolve(data.interlockingTaskSet);
        }, function(response) {
            console.log("error saving workflow task interlocking");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getActiveWorkflowActions = function() {
        var deferred = $q.defer();

        WorkflowsFactory.workflowActions().get().$promise.then(function(data) {
            service.workflowActions = data.workflowActions;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflows actions list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWorkflowActions = function(customEditActionsOnly = false) {
        const deferred = $q.defer();
        let params = {};
        if (customEditActionsOnly) {
            params.customEditActionsOnly = 1;
            params.showAll = 0;
        } else {
            params.showAll = 1;
        }

        WorkflowsFactory.workflowActions().get(params).$promise.then(function(data) {
            service.workflowActions = data.workflowActions;
            deferred.resolve(data.workflowActions);
        }, function(response) {
            console.log("error loading workflows actions list");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getRoutingRuleSets = function(workflowId, showAutomated) {
        var deferred = $q.defer();

        var params = {
            'routingRuleSets': 'routingRuleSets',
            'workflowId': workflowId
        };

        if (showAutomated) {
            params.automated = 1;
        }

        WorkflowsFactory.routingRuleSets().get(params).$promise.then(function(data) {
            service.routingRuleSets = data.routingRuleSets;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflows tasks list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addRoutingRuleSet = function(param, showAutomated) {
        var deferred = $q.defer();

        if (showAutomated) {
            param.automated = 1;
        }

        WorkflowsFactory.routingRuleSets().save({
            'routingRuleSets': 'routingRuleSet'
        }, param).$promise.then(function(data) {
            if (!data.errors) {
                deferred.resolve(data.routingRuleSet);
            } else {
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("Error saving routing rule set");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.updateRoutingRuleSet = function(param, showAutomated) {
        var deferred = $q.defer();

        if (showAutomated) {
            param.automated = 1;
        }

        WorkflowsFactory.routingRuleSets().update({
            'routingRuleSets': 'routingRuleSet'
        }, param).$promise.then(function(data) {
            if (!data.errors) {
                deferred.resolve(data.routingRuleSet);
            } else {
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("Error saving routing rule set");
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.deleteRoutingRuleSet = function(ruleId) {
        var deferred = $q.defer();

        WorkflowsFactory.routingRuleSets().delete({
            'routingRuleSets': 'routingRuleSet',
            'id': ruleId
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error saving workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getRoutingRules = function(routingRuleSetId) {
        var deferred = $q.defer();

        WorkflowsFactory.routingRules().get({
            'routingRules': 'routingRules',
            'routingRuleSetId': routingRuleSetId
        }).$promise.then(function(data) {
            service.routingRulesList = data.routingRules;
            deferred.resolve();
        }, function(response) {
            console.log("error loading workflows tasks list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addRoutingRules = function(param, scheduledRouting) {
        var deferred = $q.defer();

        WorkflowsFactory.routingRules().save({
            'scheduledRouting': scheduledRouting,
            'routingRules': 'routingRule'
        }, param).$promise.then(function(data) {
            deferred.resolve(data.routingRule);
        }, function(response) {
            console.log("error saving routing Rule");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateRoutingRules = function(param, scheduledRouting) {
        var deferred = $q.defer();

        WorkflowsFactory.routingRules().update({
            'scheduledRouting': scheduledRouting,
            'routingRules': 'routingRule'
        }, param).$promise.then(function(data) {
            deferred.resolve(data.routingRule);
        }, function(response) {
            console.log("error updating routing rule");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteRoutingRule = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.routingRules().delete({
            'routingRules': 'routingRule',
            'id': id
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting routing rule");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getRoutingConditions = function(routingRuleSetId) {
        var deferred = $q.defer();

        WorkflowsFactory.routingCondition().get({
            'routingConditions': 'routingConditions',
            'routingRuleSetId': routingRuleSetId
        }).$promise.then(function(data) {
            service.routingConditions = data.routingConditions;
            deferred.resolve();
        }, function(response) {
            console.log("error loading routing conditions list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.addRoutingCondition = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.routingCondition().save({
            'routingConditions': 'routingCondition'
        }, param).$promise.then(function(data) {
            deferred.resolve(data.routingCondition);
        }, function(response) {
            console.log("error saving routing conditions");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.updateRoutingCondition = function(param) {
        var deferred = $q.defer();

        WorkflowsFactory.routingCondition().update({
            'routingConditions': 'routingCondition'
        }, param).$promise.then(function(data) {
            deferred.resolve(data.routingCondition);
        }, function(response) {
            console.log("error updating routing conditions");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteRoutingCondition = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.routingCondition().delete({
            'routingConditions': 'routingCondition',
            'id': id
        }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error deleting routing condition");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getOrderStatuses = function() {
        var deferred = $q.defer();

        WorkflowsFactory.statuses().get({
            'statuses': 'orderStatuses'
        }).$promise.then(function(data) {
            service.orderStatusList = data.statuses;
            deferred.resolve();
        }, function(response) {
            console.log("error loading order statuses list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getClientStatuses = function() {
        var deferred = $q.defer();

        WorkflowsFactory.statuses().get({
            'statuses': 'clientStatuses'
        }).$promise.then(function(data) {
            service.clientStatusList = data.statuses;
            deferred.resolve();
        }, function(response) {
            console.log("error loading client statuses list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getLineItemStatuses = function() {
        var deferred = $q.defer();

        WorkflowsFactory.statuses().get({
            'statuses': 'lineItemStatuses'
        }).$promise.then(function(data) {
            service.lineItemStatusList = data.statuses;
            deferred.resolve();
        }, function(response) {
            console.log("error loading lineitem statuses list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getFlightStatuses = function() {
        var deferred = $q.defer();

        WorkflowsFactory.statuses().get({
            'statuses': 'flightStatuses'
        }).$promise.then(function(data) {
            service.flightStatusList = data.statuses;
            deferred.resolve();
        }, function(response) {
            console.log("error loading flight statuses list");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getWfTemplates = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.wfTemplates().get({ 'typeId': id }).$promise.then(function(data) {
            deferred.resolve(data.templates);
        }, function(response) {
            console.log("error getting workflow templates");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.saveWFEntity = function(obj) {
        var deferred = $q.defer();

        WorkflowsFactory.formEntity().save(obj).$promise.then(function(data) {
            if(!data.errors){
                deferred.resolve(data);
            }else{
                deferred.reject(data.errors);
            }
        }, function(response) {
            console.log("error saving workflow templates");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getTemplateWorkflowTypes = function() {
        var deferred = $q.defer();

        WorkflowsFactory.getTemplateWorkflowTypes().get().$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting template workflow types");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getClustersWithoutWf = function() {
        var deferred = $q.defer();

        WorkflowsFactory.wfTemplates().get({ 'type': 'clustersWithoutWorkflow' }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting Clusters Without workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getProductsWithoutWf = function() {
        var deferred = $q.defer();

        WorkflowsFactory.wfTemplates().get({ 'type': 'productsWithoutWorkflow' }).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting products Without workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getFullWorkflow = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.workflows().get({ 'workflow': 'fullWorkflow', 'id': id }).$promise.then(function(data) {
            deferred.resolve(data.workflow);
        }, function(response) {
            console.log("error getting products Without workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getActiveWorkflowForProduct = function(productId, typeId) {
        var deferred = $q.defer();

        var params = {
            'productId': productId,
            'typeId': typeId
        };

        WorkflowsFactory.activeWorkflow().get(params).$promise.then(function(data) {
            if (data.errors) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve(data.workflow);
            }
        }, function(response) {
            deferred.reject(response);
        });

        return deferred.promise;
    };

    service.getWfCoordinates = function(id) {
        var deferred = $q.defer();

        WorkflowsFactory.workflows().get({ 'workflow': 'workflowCoords', 'workflow_id': id }).$promise.then(function(data) {
            deferred.resolve(data.workflowCoords);
        }, function(response) {
            console.log("error getting products Without workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    service.saveWfCoordinates = function(id, obj) {
        var deferred = $q.defer();

        WorkflowsFactory.workflows().save({ 'workflow': 'workflowCoords', 'workflow_id': id }, obj).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("error getting products Without workflow");
            deferred.reject();
        });

        return deferred.promise;
    };

    return service;
}

WorkflowsFactory.$inject = ['$resource', 'AppConfig'];

function WorkflowsFactory($resource, AppConfig) {
    var factory = {};

    factory.workflows = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/:workflow/', {
            workflow: '@workflow'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.toggleWorkflowState = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/toggleWorkflowState', null, {
            'update': {
                method: 'PUT',
                isArray: false
            }
        });
    };

    factory.workflowActions = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/workflowActions', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.workflowAction = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/workflowAction', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.activeWorkflow = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/activeWorkflow', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.workflowTasks = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/:workflowTasks', {
            workflowTasks: '@workflowTasks'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.workflowTaskInterlockings = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/:workflowTaskInterlockings', {
            workflowTaskInterlockings: '@workflowTaskInterlockings'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.interlockingTaskSets = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/:interlockingTaskSets', {
            interlockingTaskSets: '@interlockingTaskSet'
        }, {
            'save': {
                method: 'POST'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.workflowTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'workflows/workflowTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.routingRuleSets = function() {
        return $resource(AppConfig.IO_API_URL + 'routing/:routingRuleSets', {
            routingRuleSets: '@routingRuleSets'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.routingRules = function() {
        return $resource(AppConfig.IO_API_URL + 'routing/:routingRules', {
            routingRules: '@routingRules'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.routingCondition = function() {
        return $resource(AppConfig.IO_API_URL + 'routing/:routingConditions', {
            routingConditions: '@routingConditions'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            }
        });
    };

    factory.statuses = function() {
        return $resource(AppConfig.IO_API_URL + 'statuses/:statuses', {
            statuses: '@statuses'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    };

    factory.wfTemplates = function() {
        return $resource(AppConfig.IO_API_URL + 'templates/:type', {
            type: '@type'
        }, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.formEntity = function() {
        return $resource(AppConfig.IO_API_URL + 'workflowBuilder', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.getTemplateWorkflowTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'templates/workflowTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    return factory;
}